import api from "./api";

const codeBankNbfcService = {
  list: () => api.get("/code-bank-nbfcs"),
  create: (payload) => api.post("/code-bank-nbfcs", payload),
  update: (id, payload) => api.patch(`/code-bank-nbfcs/${id}`, payload),
  remove: (id) => api.delete(`/code-bank-nbfcs/${id}`),
  downloadExcel: () =>
    api.get("/code-bank-nbfcs/export", { responseType: "blob" }),
};

export default codeBankNbfcService;
